<template>
  <div class="product-page">
    <button type="button" class="modal-closer" @click="hideProduct">
      <div class="modal-closer-icon">
        <svg
          width="24"
          height="18"
          viewBox="0 0 24 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5 0.162109L12.625 2.03711L18.3379 7.75H0.75V10.25H18.3379L12.625 15.9629L14.5 17.8379L23.3379 9L14.5 0.162109Z"
            fill="#999999"
          />
        </svg>
      </div>
    </button>
    <div class="product-detail-promo" v-if="promo > 0">
      {{ __('sale') }} -{{ promo }}%
    </div>
    <div class="product-detail-picture">
      <div @click="share" class="product-detail-share" v-if="canShare">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="27"
          fill="none"
        >
          <path
            fill="#CCC"
            d="M19 10l-3-2-7 4a5 5 0 0 1 0 3l7 4 3-2c3 0 5 2 5 5 0 2-2 5-5 5a5 5 0 0 1-4-7l-7-4c-1 2-2 2-3 2-3 0-5-2-5-4 0-3 2-5 5-5l3 2 7-4V5c0-2 2-4 4-4 3 0 5 2 5 4 0 3-2 5-5 5z"
          />
        </svg>
      </div>
      <img
        class="product-detail-img"
        v-if="fullProduct.img_link"
        :src="currentImage || product.img_link"
        :alt="fullProduct['name_' + lang]"
      />
      <div class="product-detail-img" v-else></div>
    </div>
    <div class="product-detail-thumbnail-container" v-if="thumbnails.length">
      <div
        class="product-detail-thumbnail"
        v-for="(p, i) in thumbnails"
        v-bind:key="i"
        @click="currentImage = i"
      >
        <img :src="p" :alt="thumbnailDescriptions[i] || ''" />
      </div>
    </div>
    <div class="product-detail-info">
      <div class="product-detail-title-header">
        <h1 class="product-detail-title">{{ fullProduct['name_' + lang] }}</h1>
        <div class="float-right product-detail-addtocart">
          <StyledQuick @click="addToCart" :r="r">
            &euro;
            {{ formatPrice(price) }}
          </StyledQuick>
          <div class="product-detail-price" v-if="isPromo">
            &euro; {{ formatPrice(listPrice) }}
          </div>
        </div>
      </div>
      <div class="product-detail-description product-detail-expanded">
        <span v-html="fullProduct['description_' + lang]" />
      </div>
      <h1 class="product-detail-title" v-if="fullProduct.specs">
        {{ __('specifications') }}
      </h1>
      <div>
        <table>
          <tbody>
            <tr v-for="(spec, i) in fullProduct.specs" v-bind:key="i">
              <td class="td-left">{{ spec.label }}</td>
              <td class="td-right">{{ spec.values.join('\n') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="product-detail-link">
        {{ __('all details') }}
        <a :href="link" target="_blank">{{ __('product page') }}</a>
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <div class="footer-row">
          <button @click="addToCart" class="btn has-icon prim-btn">
            <icon
              class="btn-icon"
              name="add-to-cart"
              bg="#2DC76D"
              fill="white"
            />
            {{ removeEmoji(__('in cart')) }}
          </button>
          <button @click="moreLikeThis" class="btn has-icon sec-btn">
            <icon class="btn-icon" name="plus" bg="white" fill="#005aa6" />
            {{ removeEmoji(__('more like this')) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyButton from './MyButton.vue'
import StyledQuick from './StyledQuick.vue'

import { envReplace, refParam, removeEmoji } from '../util.js'
import { getJSON, postJSON } from '../../../src/lib/fetch'
import { unserialize } from '@bothrs/util/url'

import translationList from '../../../bot/dist/translations.esm.js'

const translate = translator(translationList)

export default {
  components: {
    MyButton,
    StyledQuick
  },
  props: {
    p: null
  },
  data() {
    return {
      detail: null,
      imgIndex: 0
    }
  },
  computed: {
    product() {
      // TODO: check if possible to get data from props
      // so the component can be reused
      return this.p || this.$root.product || window.product
    },
    fullProduct() {
      return { ...this.product, ...this.detail }
    },
    promo() {
      return Math.round((100 * (this.listPrice - this.price)) / this.listPrice)
    },
    price() {
      return parseFloat(this.product.price)
    },
    lang() {
      return this.$root.state.lang || 'nl'
    },
    listPrice() {
      return parseFloat(this.product.list_price)
    },
    link() {
      return refParam(envReplace(this.product['link_' + this.lang]))
    },
    imgLink() {
      return envReplace(this.product.img_link)
    },
    id() {
      const { link_nl } = this.product
      return link_nl.slice(link_nl.lastIndexOf('/') + 1)
    },
    canShare() {
      return process.browser && window.navigator.share
    },
    r() {
      return {
        icon: 'add-to-cart',
        fill: '#2DC76D',
        color: 'white'
      }
    },
    lang() {
      return this.$root.state.lang || 'nl'
    },
    isPromo() {
      return this.price < this.listPrice
    },
    currentImage: {
      get() {
        return (
          (this.imgIndex && this.images[this.imgIndex]) || this.product.img_link
        )
      },
      set(idx) {
        this.imgIndex = idx
      }
    },
    assets() {
      return (
        (this.product &&
          this.fullProduct &&
          this.fullProduct.assets &&
          this.fullProduct.assets[0]) ||
        {}
      )
    },
    images() {
      return Object.values(this.assets.ItemAngleFullImage || [])
    },
    thumbnails() {
      return Object.values(this.assets.ItemAngleThumbnail || [])
    },
    thumbnailDescriptions() {
      return Object.values(this.assets.ItemAngleThumbnailShortDesc || [])
    }
  },
  methods: {
    removeEmoji,
    __(key) {
      return translate(this.lang, key)
    },
    close() {
      this.product = null
    },
    addToCart() {
      window.top.postMessage(
        {
          type: 'addToCart',
          productId: this.product.product,
          product: this.product
        },
        '*'
      )
    },
    formatPrice(price) {
      if (!price) return
      return price.toString().replace('.', ',')
    },
    share() {
      window.navigator.share({
        title: this.product['name_' + this.lang] || 'Dreamland product',
        text: this.product['name_' + this.lang] || 'Check this product',
        url: this.link || 'https://dreamland.be'
      })
    },
    moreLikeThis() {
      this.$root.productDetail = null
      window.top.postMessage({ type: 'hideProduct' }, '*')
      window.top.postMessage(
        { type: 'moreLikeThis', product: this.product },
        '*'
      )
    },
    hideProduct() {
      this.$root.productDetail = null
      window.top.postMessage({ type: 'hideProduct' }, '*')
    }
  },
  async mounted() {
    getJSON('/api/products/' + this.id + '?lang=' + this.lang).then(product => {
      this.detail = product
    })
  },
  watch: {
    async id(v, o) {
      this.imgIndex = 0
      this.detail = await getJSON(
        '/api/products/' + this.id + '?lang=' + this.lang
      )
    }
  }
}
function translator(translations) {
  const lookup = Object.create(null)
  for (var i = translations.length - 1; i >= 0; i--) {
    lookup[translations[i].key] = translations[i]
  }

  return (lang, key) => {
    const regex = new RegExp('^' + escapeRegExp(key) + '[d]*$')
    const possibilities = Object.keys(lookup).filter(k => regex.test(k))
    const index = Math.ceil(Math.random() * possibilities.length) - 1

    const match = lookup[possibilities[index]] || lookup[key]
    return (match && (match[lang] || match.nl)) || key
  }
}
function escapeRegExp(stringToGoIntoTheRegex) {
  return stringToGoIntoTheRegex.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
}
function ucfirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
</script>

<style>
.container {
  max-width: 30em;
  margin: 0 auto;
  padding: 0 1em;
}
.product-page {
  background-color: white;
  position: relative;
  width: calc(100% - 400px);
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 1em;
}
.btn-icon.icon {
  position: relative;
  top: -2px;
  display: inline-block;
  vertical-align: middle;
  line-height: 22px;
  height: 32px;
  width: 32px;
  padding: 4px;
  border-radius: 32px;
  font-size: 24px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.modal-closer {
  position: absolute;
  z-index: 13;
  top: 0;
  right: 0;
  margin: 0;
  border: 0;
  padding: 8px;
  background: none;
  transition: transform 0.2s;
}
.modal-closer:hover {
  transform: scale(1.25);
  transition: all 0.2s;
}
.modal-closer:focus {
  opacity: 0.5;
  outline: none;
}
.modal-closer-icon {
  border-radius: 50%;
  padding: 13px;
  padding-right: 0;
}
.modal-closer-icon > svg {
  display: block;
  margin: 0;
}
.modal-closer .fill-fg {
  fill: white;
}
.product-detail-title-header {
  display: flex;
  justify-content: space-between;
}
.product-detail-promo {
  position: absolute;
  display: block;
  right: -5.5em;
  top: 2.8em;
  width: 16em;
  background: #e2260f;
  color: white;
  border-radius: 1.5em;
  line-height: 35px;
  padding: 0 1.5em;
  transform-origin: 50% 50%;
  text-align: center;
  transform: rotate(40deg);
  z-index: 2;
}
@media (max-width: 501px) {
  .product-detail-promo {
    text-align: center;
    width: 16em;
    right: -6.5em;
    top: 1.8em;
    transform: rotate(40deg);
  }
}
.product-detail-img {
  display: block;
  height: 9em;
  width: auto;
  max-width: 100%;
  margin: 0 auto;
}
.product-detail-title {
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0.666667px;
  color: #005aa6;
}
.product-detail-description {
  color: #666666;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.666667px;
  max-height: 200px;
  overflow: hidden;
  position: relative;
}
.product-detail-atc {
  background-color: #2dc76d;
  color: white;
  font-size: 1.3em;
}
.product-detail-thumbnail-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 5px;
  overflow-x: auto;
  overflow-y: hidden;
}
.product-detail-thumbnail img {
  max-width: 48px;
  object-fit: contain;
}
.product-detail-thumbnail {
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 3px;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
}
.product-detail-thumbnail + .product-detail-thumbnail {
  margin-left: 10px;
}
.float-right {
  float: right;
}

/* Footer */
.footer {
  background: white;
}
.footer-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 -0.5em;
}
.footer .btn {
  border-radius: 5px;
  width: 100%;
  margin: 0 0.5em 1em;
  padding: 6px 2px 2px;
  white-space: nowrap;
}
.prim-btn.btn {
  background-color: #2dc76d;
  color: white;
  min-height: 42px;
  width: 100%;
}
.prim-btn.btn span {
  margin-top: 2px;
}
.sec-btn.btn {
  height: 42px;
  color: #005aa6;
}
@media (max-width: 410px) {
  .footer .btn {
    font-size: 14px;
  }
}

/* Specs */
.td-left {
  color: #666666;
}
.td-right {
  text-align: right;
  color: #666666;
}
table {
  border-collapse: collapse;
  width: 100%;
}
tr:nth-child(even) {
  background: white;
}
tr:nth-child(odd) {
  background: rgba(0, 0, 0, 0.1);
}
td {
  padding: 6px 10px;
  font-size: 16px;
  font-size: 11px;
  line-height: 17px;
  letter-spacing: 0.666667px;
}
.product-detail-description button {
  color: rgba(0, 0, 0, 0.3);
  margin: 0 auto;
  position: absolute;
  width: 30%;
  left: 35%;
  top: 150px;
  padding: 10px 5px;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
}
.product-detail-expanded .product-detail-description-expand {
  display: none;
}
.product-detail-expanded {
  max-height: 2000px;
  overflow: auto;
}
.product-detail-picture {
  padding-top: 0.5em;
  display: flex;
}
.product-detail-share {
  align-self: center;
  cursor: pointer;
}
.padding-bottom {
  padding-bottom: 3em;
}
.slide2-enter-active,
.slide2-leave-active {
  transition: transform 0.5s;
}
.slide2-enter,
.slide2-leave-to {
  transform: translateY(5em);
}
.between {
  display: flex;
  justify-content: left;
  align-items: center;
}
.between .quick {
  margin-left: 0;
}
.product-detail-price {
  color: #a62f2f;
  text-decoration: line-through;
}
.product-detail-link {
  width: 100%;
  text-align: right;
  color: #666666;
  margin: 1em 0;
}
.product-detail-link a {
  text-decoration: underline;
  color: #005aa6;
}
.product-detail-addtocart button {
  position: relative;
  width: 100%;
  top: 0;
  left: 0;
}
.btn:hover {
  cursor: pointer;
}
</style>
